import React, { Component } from 'react';
class IdentityDocuments extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

componentDidMount(){
}


  render() {
    return (
        <>
        	<div className="mt-4 mb-4">
                <h3 className="wow fadeInUp" data-wow-delay="0.1s">{this.props.page_title}</h3>
                <div className="row g-4">


                <div className="col-md-12">
                    <div className="wow fadeInUp" data-wow-delay="0.5s">
                        <form action="" method="post">
                            <div className="row g-3">

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="file" className="form-control" id="full_name" placeholder="Current Residential Address"/>
                                        <label for="name">Aadhaar Card</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="file" className="form-control" id="bate_of_birth" placeholder="Permanent Address"/>
                                        <label for="name">PAN Card</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="file" className="form-control" id="gender" placeholder="Permanent Address"/>
                                        <label for="name">GSTIN</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="file" className="form-control" id="gender" placeholder="Permanent Address"/>
                                        <label for="name">CIN no/ registration number</label>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="gender" placeholder="Permanent Address"/>
                                        <label for="name">Business Address</label>
                                    </div>
                                </div>


                                <div className="col-md-12">
                                  <div className="col-md-2 p-0">
                                      <button className="btn btn-primary w-100 py-3" type="button">Submit</button>
                                  </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </div>

        </>
    );
  }
}

export default IdentityDocuments;
